import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Video, Podcast, Film, ArrowRight } from 'lucide-react';

const mediaTypeIcons = {
  book: BookOpen,
  video: Video,
  podcast: Podcast,
  documentary: Film
};

const mediaTypeColors = {
  book: 'text-amber-400 bg-amber-400/10',
  video: 'text-red-400 bg-red-400/10',
  podcast: 'text-purple-400 bg-purple-400/10',
  documentary: 'text-blue-400 bg-blue-400/10'
};

export default function MediaCard({ media }) {
  const Icon = mediaTypeIcons[media.media_type] || BookOpen;
  const colorClass = mediaTypeColors[media.media_type] || 'text-white/60 bg-white/10';

  return (
    <Link
      to={`/media/${media.media_id}`}
      className="card-dark block overflow-hidden group"
      data-testid={`media-card-${media.media_id}`}
    >
      {/* Thumbnail */}
      {media.thumbnail_url && (
        <div className="relative h-48 overflow-hidden">
          <img
            src={media.thumbnail_url}
            alt={media.title}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
          
          {/* Type badge */}
          <div className="absolute bottom-4 left-4">
            <span className={`inline-flex items-center gap-1.5 px-2 py-1 text-xs font-mono uppercase tracking-wider rounded-sm ${colorClass}`}>
              <Icon className="w-3 h-3" />
              {media.media_type}
            </span>
          </div>
        </div>
      )}

      {/* Content */}
      <div className="p-5">
        <h3 className="font-heading font-semibold text-lg text-white mb-2 group-hover:text-cyan-400 transition-colors line-clamp-2">
          {media.title}
        </h3>
        
        {media.authors?.length > 0 && (
          <p className="text-white/40 text-sm mb-2">
            by {media.authors.join(', ')}
          </p>
        )}
        
        <p className="text-white/50 text-sm line-clamp-3 mb-4">
          {media.description}
        </p>

        {/* Key revelations */}
        {media.key_revelations?.length > 0 && (
          <div className="space-y-1 mb-4">
            {media.key_revelations.slice(0, 2).map((rev, idx) => (
              <div key={idx} className="flex items-start gap-2 text-xs text-white/40">
                <span className="text-cyan-400 mt-0.5">•</span>
                <span className="line-clamp-1">{rev}</span>
              </div>
            ))}
          </div>
        )}

        <div className="flex items-center justify-end">
          <ArrowRight className="w-4 h-4 text-white/20 group-hover:text-cyan-400 group-hover:translate-x-1 transition-all" />
        </div>
      </div>
    </Link>
  );
}
